import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import SixDotsIcon from "../../shared/Icons/SixDotsIcon";
import Typography from "../../shared/typography/Typography";
import { DraggableItem } from "./style";

interface IItem {
  id: string;
  title: string;
}

interface IProps {
  list: IItem[];
  disabledDragItens: string[];
  handleDragEnd: (result: any) => void;
}

export const DragAndDropList = ({list, disabledDragItens, handleDragEnd}: IProps) => (
  <DragDropContext onDragEnd={handleDragEnd}>
    <Droppable droppableId="droppable">
      {(provided, snapshot) => (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
          style={{display: 'flex', flexDirection: 'column'}}
        >
          {list.map(({title, id}, index) => !['loginAndregister', 'redundancy'].includes(id) && (
            <Draggable
              key={title} 
              draggableId={title} 
              index={index}
              isDragDisabled={disabledDragItens.includes(id)}
            >
              {(provided, snapshot) => (
                <DraggableItem
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                >
                  {!disabledDragItens.includes(id) && <SixDotsIcon color="label" />}
                  <Typography
                    color={disabledDragItens.includes(id) ? 'label' : 'title'} 
                    type="headingXXS"
                  >
                    {title}
                  </Typography>
                </DraggableItem>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </DragDropContext>
)